export const nodeDefaults = {
  fileNode: { data: { protocol: 'SFTP', sort_order: 'ASCENDING', file_operation: 'MOVE', port:22} },
  apiNode: { data: { method: 'GET'} },
  taskServiceNode: { data: { assigned_user: '', assigned_group:'', task_type: 'manual', unit: 'hours', priority:'low'} },
  timerNode: {data: {timer_unit:'minute'}}
};

export const mandatoryFields = {
    taskServiceNode : ['assigned_group'],
    fileNode: ['server_host']
}

export const convertNodeNameToLocal = (nodeName) => {
  switch (nodeName) {
    case 'triggerNode':
      return 'Trigger Node';
    case 'outputNode':
      return 'Output Node';
    case 'agentNode':
      return 'Agent Node';
    case 'modelNode':
      return 'Model Node';
    case 'knowledgeNode':
      return 'Knowledge Node';
    case 'dataSourceNode':
      return 'Data Source Node';
    case 'apiNode':
      return 'API Node';
    case 'taskServiceNode':
      return 'Task Service Node';
    case 'timerNode':
      return 'Timer Node';
    case 'classifierNode':
      return 'Classifier Node';
    case 'emailOutNode':
      return 'Email Out Node';
    case 'codeNode':
      return 'Code Node';
    case 'webHookNode':
      return 'Web Hook Node';
    case 'toolNode':
      return 'Tool Node';
    case 'fileNode':
      return 'File Node';
    default:
      return nodeName; 
  }
};
